<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form>
                            <v-text-field ref="username" @keyup.enter="$refs.password.focus" v-model="username" prepend-icon="credit_card" label="Library Card Number" type="text" autofocus required browser-autocomplete="off"></v-text-field>
                            <v-text-field ref="password" @keyup.enter="$refs.login.click" v-model="password" prepend-icon="lock" label="PIN" type="password" required browser-autocomplete="off"></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="pb-3">
                        <v-btn ref="login" block color="primary" @click="login">Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'login',
    data () {
        return {
            username: '',
            password: ''
        }
    },
    created( ) {
        if ( this.$store.state.patron.loggedIn ) {
           this.$store.dispatch( 'patron/logout' );
        }
    },
    mounted( ) {
        this.$refs.username.focus( );
    },
    computed: {
        loggedIn( ) {
            return this.$store.state.patron.loggedIn;
        },
        loginStatus( ) {
            return this.$store.state.patron.loginStatus;
        }
    },
    watch: {
        loggedIn( updated, orginial ) {
            if ( updated ) {
                this.$router.push( { name: 'historyscantab' } );
            }
        },
        loginStatus( updated, orginial ) {
            console.log( 'loginStatus changed', updated );
            switch( updated ) {
                case 'error':
                    this.username = '';
                    this.password = '';
                    break;
                case 'idle':
                    this.$refs.username.focus( );
                    break;
            }
        }
    },
    methods: {
        login( ) {
            this.$store.dispatch( 'patron/login', {
                login: this.username,
                password: this.password
            } );
        }
    }
}
</script>
